<template>
  <FirstAccessContent class="mt-24"></FirstAccessContent>
</template>

<script>
import FirstAccessContent from '../../components/organisms/FirstAccessContent/FirstAccessContent.vue'

export default {
  name: 'FirstAccessView',
  components: {
    FirstAccessContent
  }
}
</script>